(() => {
  const locale = (document.documentElement.lang || '').slice(0, 2).toLowerCase();

  if (locale !== 'en') return;

  const replacements = new Map([
    ['Har du spørgsmål?', 'Have questions?'],
  ]);

  const translateTextNodes = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      const nextValue = replacements.get(textNode.nodeValue?.trim());

      if (!nextValue) continue;

      textNode.nodeValue = nextValue;
    }
  };

  const translateWilldesk = () => {
    translateTextNodes(document.getElementById('__helpdesk-channel'));
  };

  const observer = new MutationObserver(() => {
    translateWilldesk();
  });

  const start = () => {
    translateWilldesk();

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    return;
  }

  start();
})();
